'use strict';

var _                = require('underscore');
var $                = require('jquery');
var Core             = require('../core/core.js');
var TopNavTitle      = require('./topnav__title.js');
var TopNavConnection = require('./topnav__connection.js');
var TopNavVersion    = require('./topnav__version.js');
var TopNavTabButton  = require('./topnav__tabbutton.js');
var TopNavAvatar     = require('./topnav__avatar.js');

/**
 * Creates a Top Menu
 *
 * @class
 */

class TopNav extends Core {

    _defaults() {
        return {
            target: 'body',
            fields: {
                'menu_logo': {
                    'img': '',
                    'link': ''
                }
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <nav class="editor__topnav clearfix">
                <div class="editor__topnav__left">
                     <div class='float editor__topnav__logo'>
                        <a href="<%= external_url(menu_logo.link) %>" class="js-editor__topnav__logo">
                            <img src='<%= external_url(menu_logo.img) %>' width='48' height='48'>
                        </a>
                    </div>
                    <div class="float editor__topnav__left__buttons"></div>
                    <div class='float js-menu-title'></div>
                </div>
                <div class="editor__topnav__right">
                    <div class="float js-sitemenu__right__connection"></div>
                    <div class="float js-sitemenu__right__version"></div>
                    <div class="right js-sitemenu__right__tabs"></div>
                </div>
            </nav>
        `;

        super.render();

    }


    /**
     * Add a title in the menu
     * @param {String} title - A string with the desired title
     * @returns none
     */

    addTitle(title, readonly){
        return new TopNavTitle({
            target: $('.js-menu-title', this.$el),
            fields: {
                'name': (title != undefined ? title : 'The Unnamed Project'), //allow empty string as title
                'readonly': readonly
            }
        });
    }

    /**
     * Add a connection state area to the menu
     * @param {String} message - The connection message
     * @param {String} [type="normal"] - The type of connection,
     *                        can be "normal", "warning" or "error"
     * @returns {TopNavConnection}
     */

    addConnectionMenu(message, type){
        return new TopNavConnection({
            target: $('.js-sitemenu__right__connection', this.$el),
            fields: {
                'message': message,
                'type': type
            }
        });
    }

    addVersion(){
        return new TopNavVersion({
            target: $('.js-sitemenu__right__version', this.$el)
        });
    }

	/**
	 * Add a button to switch between tabs
	 * @param {String} name - the title for our button
	 * @param {String} link - the link (if any) for our button
	 * @param {String} icon - the icon string for our button
	 * @param {String} description - description will appear as title/tooltip
	 * @param {String} position - position of button, left or right
	 * @returns {TopNavTabButton}
	 */
    /**
     * Add an avatar to the menu
     * @param {String} profile_url - url to profile page
     * @param {String} avatar_url - url to avatar image
     * @returns {TopNavConnection}
     */

    addAvatar(avatar_url, profile_url){
        return new TopNavAvatar({
            target: $('.js-sitemenu__right__tabs', this.$el),
            fields: {
                'avatar_url': avatar_url,
                'profile_url': profile_url
            }
        });
    }

    /**
     * Add a button to switch between tabs
     * @param {String} name - the title for our button
     * @param {String} link - the link (if any) for our button
     * @param {String} icon - the icon string for our button
     * @param {String} description - description will appear as title/tooltip
     * @param {String} position - position of button, left or right
     * @returns {TopNavTabButton}
     */

    addTabButton(name, link, icon, description, position, border) {
        return  new TopNavTabButton({
            target: this._getPositionContainer(this, position),
            fields: {
                'name': name,
                'link': link,
                'icon': icon,
                'description': description,
                'border': border
            }
        });
    }

    _getPositionContainer(ref, position){
        switch(position){
            case 'left':
                return $('.editor__topnav__left__buttons', ref.$el);
                break;
            case 'right':
                return $('.js-sitemenu__right__tabs', ref.$el);
                break;
            default:
                return $('.js-sitemenu__right__tabs', ref.$el);
                break;
        }
    }

    

    
}
module.exports = TopNav;
